var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPersonBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#769DFF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6901 13.8014C15.905 13.8014 17.7005 11.9804 17.7005 9.73396C17.7005 7.48757 15.905 5.6665 13.6901 5.6665C11.4752 5.6665 9.67969 7.48757 9.67969 9.73396C9.67969 11.9804 11.4752 13.8014 13.6901 13.8014Z",
    fill: "#2E66F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7096 19.6723C21.7096 21.0583 18.1143 22.7497 13.6888 22.7497C9.26321 22.7497 5.66797 20.9095 5.66797 19.6723C5.66797 17.9653 9.26321 15.4282 13.6888 15.4282C18.1143 15.4282 21.7096 17.9653 21.7096 19.6723Z",
    fill: "#2E66F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPersonBg);
export default __webpack_public_path__ + "static/media/ic_person_bg.4d1cb75e2b9efe035ccb2403bfcbccf2.svg";
export { ForwardRef as ReactComponent };